import * as ambassadorWixAutomationsTriggercatalogV1Trigger from './automations-triggercatalog-v1-trigger-trigger-catalog.http.js';
import * as ambassadorWixAutomationsTriggercatalogV1TriggerTypes from './automations-triggercatalog-v1-trigger-trigger-catalog.types.js';
import * as ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes from './automations-triggercatalog-v1-trigger-trigger-catalog.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createTrigger(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.CreateTriggerRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.CreateTriggerRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.CreateTriggerResponse,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.CreateTriggerResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsTriggercatalogV1Trigger.createTrigger(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/triggers',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateTrigger(): __PublicMethodMetaInfo<
  'PATCH',
  { triggerId: string },
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.UpdateTriggerRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.UpdateTriggerRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.UpdateTriggerResponse,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.UpdateTriggerResponse
> {
  const payload = { trigger: { id: ':triggerId' } } as any;

  const getRequestOptions =
    ambassadorWixAutomationsTriggercatalogV1Trigger.updateTrigger(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/trigger/{trigger.id}',
    pathParams: { triggerId: 'triggerId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteTriggerByAppIdAndKey(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.DeleteTriggerByAppIdAndKeyRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.DeleteTriggerByAppIdAndKeyRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.DeleteTriggerByAppIdAndKeyResponse,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.DeleteTriggerByAppIdAndKeyResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsTriggercatalogV1Trigger.deleteTriggerByAppIdAndKey(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/trigger',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTriggerByAppIdAndKey(): __PublicMethodMetaInfo<
  'GET',
  { appId: string; triggerKey: string },
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.GetTriggerByAppIdAndKeyRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.GetTriggerByAppIdAndKeyRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.GetTriggerByAppIdAndKeyResponse,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.GetTriggerByAppIdAndKeyResponse
> {
  const payload = { appId: ':appId', triggerKey: ':triggerKey' } as any;

  const getRequestOptions =
    ambassadorWixAutomationsTriggercatalogV1Trigger.getTriggerByAppIdAndKey(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/triggers/apps/{appId}/keys/{triggerKey}',
    pathParams: { appId: 'appId', triggerKey: 'triggerKey' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryTriggers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.QueryTriggersRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.QueryTriggersRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.QueryTriggersResponse,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.QueryTriggersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsTriggercatalogV1Trigger.queryTriggers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/triggers/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function resolveTriggers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.ResolveTriggersRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.ResolveTriggersRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.ResolveTriggersResponse,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.ResolveTriggersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsTriggercatalogV1Trigger.resolveTriggers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/triggers/resolve',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTriggerDynamicSchema(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.GetTriggerDynamicSchemaRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.GetTriggerDynamicSchemaRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.GetDynamicSchemaResponse,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.GetDynamicSchemaResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsTriggercatalogV1Trigger.getTriggerDynamicSchema(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/triggers/dynamic_schema',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getIdentitiesSchema(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.GetIdentitiesSchemaRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.GetIdentitiesSchemaRequest,
  ambassadorWixAutomationsTriggercatalogV1TriggerUniversalTypes.GetIdentitiesSchemaResponse,
  ambassadorWixAutomationsTriggercatalogV1TriggerTypes.GetIdentitiesSchemaResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsTriggercatalogV1Trigger.getIdentitiesSchema(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/triggers/identities_schema',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Trigger as TriggerOriginal,
  TimeUnit as TimeUnitOriginal,
  TimeUnitWithLiterals as TimeUnitWithLiteralsOriginal,
  Segment as SegmentOriginal,
  SegmentWithLiterals as SegmentWithLiteralsOriginal,
  SourceType as SourceTypeOriginal,
  SourceTypeWithLiterals as SourceTypeWithLiteralsOriginal,
  DomainEventOptions as DomainEventOptionsOriginal,
  Maturity as MaturityOriginal,
  MaturityWithLiterals as MaturityWithLiteralsOriginal,
  Filter as FilterOriginal,
  FilterFieldKeyOneOf as FilterFieldKeyOneOfOriginal,
  EntitySelector as EntitySelectorOriginal,
  ValueInputType as ValueInputTypeOriginal,
  ValueInputTypeWithLiterals as ValueInputTypeWithLiteralsOriginal,
  UserInput as UserInputOriginal,
  UserInputInputOptionsOneOf as UserInputInputOptionsOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  NumberInputOptions as NumberInputOptionsOriginal,
  BooleanInputOptions as BooleanInputOptionsOriginal,
  StaticItems as StaticItemsOriginal,
  StaticItemValue as StaticItemValueOriginal,
  FieldKeyType as FieldKeyTypeOriginal,
  FieldKeyTypeWithLiterals as FieldKeyTypeWithLiteralsOriginal,
  DynamicFieldKey as DynamicFieldKeyOriginal,
  ValueInput as ValueInputOriginal,
  ValueInputInputOptionsOneOf as ValueInputInputOptionsOneOfOriginal,
  Metadata as MetadataOriginal,
  ImplementedMethods as ImplementedMethodsOriginal,
  DebounceConfiguration as DebounceConfigurationOriginal,
  Source as SourceOriginal,
  SourceOptionsOneOf as SourceOptionsOneOfOriginal,
  RetryExperimentCreation as RetryExperimentCreationOriginal,
  TriggerSpecInfo as TriggerSpecInfoOriginal,
  ExperimentActionType as ExperimentActionTypeOriginal,
  ExperimentActionTypeWithLiterals as ExperimentActionTypeWithLiteralsOriginal,
  TriggerDeletedWithEntity as TriggerDeletedWithEntityOriginal,
  CreateTriggerRequest as CreateTriggerRequestOriginal,
  CreateTriggerResponse as CreateTriggerResponseOriginal,
  GetTriggerRequest as GetTriggerRequestOriginal,
  GetTriggerResponse as GetTriggerResponseOriginal,
  UpdateTriggerRequest as UpdateTriggerRequestOriginal,
  UpdateTriggerResponse as UpdateTriggerResponseOriginal,
  UpdateTriggerComponentRequest as UpdateTriggerComponentRequestOriginal,
  UpdateTriggerComponentResponse as UpdateTriggerComponentResponseOriginal,
  UpdateTriggerMaturityRequest as UpdateTriggerMaturityRequestOriginal,
  UpdateTriggerMaturityResponse as UpdateTriggerMaturityResponseOriginal,
  DeleteTriggerRequest as DeleteTriggerRequestOriginal,
  DeleteTriggerResponse as DeleteTriggerResponseOriginal,
  DeleteTriggerByAppIdAndKeyRequest as DeleteTriggerByAppIdAndKeyRequestOriginal,
  DeleteTriggerByAppIdAndKeyResponse as DeleteTriggerByAppIdAndKeyResponseOriginal,
  MigrateComponentToTriggerRequest as MigrateComponentToTriggerRequestOriginal,
  MigrateComponentToTriggerResponse as MigrateComponentToTriggerResponseOriginal,
  RemoveComponentDataRequest as RemoveComponentDataRequestOriginal,
  RemoveComponentDataResponse as RemoveComponentDataResponseOriginal,
  GetTriggerByAppIdAndKeyRequest as GetTriggerByAppIdAndKeyRequestOriginal,
  GetTriggerByAppIdAndKeyResponse as GetTriggerByAppIdAndKeyResponseOriginal,
  GetRuntimeTriggerRequest as GetRuntimeTriggerRequestOriginal,
  GetRuntimeTriggerResponse as GetRuntimeTriggerResponseOriginal,
  GetLatestTriggerRequest as GetLatestTriggerRequestOriginal,
  GetLatestTriggerResponse as GetLatestTriggerResponseOriginal,
  QueryRuntimeTriggersRequest as QueryRuntimeTriggersRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryRuntimeTriggersResponse as QueryRuntimeTriggersResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  QueryTriggersRequest as QueryTriggersRequestOriginal,
  QueryTriggersResponse as QueryTriggersResponseOriginal,
  ResolveTriggersRequest as ResolveTriggersRequestOriginal,
  ResolveTriggersResponse as ResolveTriggersResponseOriginal,
  GetTriggerDynamicSchemaRequest as GetTriggerDynamicSchemaRequestOriginal,
  SelectedFilterOptions as SelectedFilterOptionsOriginal,
  GetDynamicSchemaResponse as GetDynamicSchemaResponseOriginal,
  GetIdentitiesSchemaRequest as GetIdentitiesSchemaRequestOriginal,
  GetIdentitiesSchemaResponse as GetIdentitiesSchemaResponseOriginal,
  ListMarketplaceAndWhitelistTriggersRequest as ListMarketplaceAndWhitelistTriggersRequestOriginal,
  ListMarketplaceAndWhitelistTriggersResponse as ListMarketplaceAndWhitelistTriggersResponseOriginal,
  ListWhitelistTriggerAppsRequest as ListWhitelistTriggerAppsRequestOriginal,
  ListWhitelistTriggerAppsResponse as ListWhitelistTriggerAppsResponseOriginal,
  BulkCreateWhitelistTriggerAppsRequest as BulkCreateWhitelistTriggerAppsRequestOriginal,
  BulkCreateWhitelistTriggerAppsResponse as BulkCreateWhitelistTriggerAppsResponseOriginal,
  BulkDeleteWhitelistTriggerAppsRequest as BulkDeleteWhitelistTriggerAppsRequestOriginal,
  BulkDeleteWhitelistTriggerAppsResponse as BulkDeleteWhitelistTriggerAppsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './automations-triggercatalog-v1-trigger-trigger-catalog.types.js';
